import { SubscriptionPlanDetails } from '../types/subscription';

// Preços anuais calculados (x10 meses de desconto)
const PREMIUM_ANNUAL = 199.90; // 10 meses pelo preço de 12
const PRO_ANNUAL = 259.90; // 10 meses pelo preço de 12

export const SUBSCRIPTION_PLANS: Record<string, SubscriptionPlanDetails> = {
  free: {
    name: 'Free',
    price: 0,
    stripePriceId: null,
    description: 'Perfeito para começar',
    features: [
      '1 evento por mês',
      '5 convidados',
      '5 receitas',
      '10 itens no acervo',
      '2 grupos de convidados',
      '1 lista de compras ativa',
      '5 itens na wishlist'
    ]
  },
  premium: {
    name: 'Basic',
    price: 19.90,
    stripePriceId: import.meta.env.VITE_STRIPE_PREMIUM_MONTHLY_PRICE_ID || 'price_premium_monthly',
    description: 'Para anfitriões dedicados',
    popular: true,
    billingInterval: 'monthly',
    features: [
      '10 eventos por mês',
      '50 convidados',
      '30 receitas',
      '100 itens no acervo',
      '10 grupos de convidados',
      '5 listas de compras ativas',
      '30 itens na wishlist',
      'Calculadora de porções automática',
      'Sincronização Google Agenda',
      'Backup automático',
      'Exportação de dados',
      'Relatórios básicos'
    ]
  },
  'premium-annual': {
    name: 'Basic',
    price: PREMIUM_ANNUAL,
    stripePriceId: import.meta.env.VITE_STRIPE_PREMIUM_ANNUAL_PRICE_ID || 'price_premium_annual',
    description: 'Para anfitriões dedicados',
    popular: true,
    billingInterval: 'annual',
    monthlyEquivalent: 19.90,
    savings: (19.90 * 12) - PREMIUM_ANNUAL,
    features: [
      '10 eventos por mês',
      '50 convidados',
      '30 receitas',
      '100 itens no acervo',
      '10 grupos de convidados',
      '5 listas de compras ativas',
      '30 itens na wishlist',
      'Calculadora de porções automática',
      'Sincronização Google Agenda',
      'Backup automático',
      'Exportação de dados',
      'Relatórios básicos'
    ]
  },
  pro: {
    name: 'Pro',
    price: 25.90,
    stripePriceId: import.meta.env.VITE_STRIPE_PRO_MONTHLY_PRICE_ID || 'price_pro_monthly',
    description: 'Para anfitriões profissionais',
    billingInterval: 'monthly',
    features: [
      'Eventos ilimitados',
      'Convidados ilimitados',
      'Receitas ilimitadas',
      'Acervo ilimitado',
      'Grupos ilimitados',
      'Listas ilimitadas',
      'Wishlist ilimitada',
      'Assistente IA',
      'Sugestões de menu',
      'Combinações de louças',
      'Dicas de etiqueta',
      'Análise de preferências',
      'Modo offline',
      'Suporte prioritário',
      'Relatórios avançados'
    ]
  },
  'pro-annual': {
    name: 'Pro',
    price: PRO_ANNUAL,
    stripePriceId: import.meta.env.VITE_STRIPE_PRO_ANNUAL_PRICE_ID || 'price_pro_annual',
    description: 'Para anfitriões profissionais',
    billingInterval: 'annual',
    monthlyEquivalent: 25.90,
    savings: (25.90 * 12) - PRO_ANNUAL,
    features: [
      'Eventos ilimitados',
      'Convidados ilimitados',
      'Receitas ilimitadas',
      'Acervo ilimitado',
      'Grupos ilimitados',
      'Listas ilimitadas',
      'Wishlist ilimitada',
      'Assistente IA',
      'Sugestões de menu',
      'Combinações de louças',
      'Dicas de etiqueta',
      'Análise de preferências',
      'Modo offline',
      'Suporte prioritário',
      'Relatórios avançados'
    ]
  }
};

export const PLAN_ORDER = ['free', 'premium', 'pro'] as const;

// Helper para obter plano pelo intervalo
export const getPlanByInterval = (plan: string, interval: 'monthly' | 'annual') => {
  if (plan === 'free') return SUBSCRIPTION_PLANS.free;
  if (interval === 'annual') {
    return SUBSCRIPTION_PLANS[`${plan}-annual`] || SUBSCRIPTION_PLANS[plan];
  }
  return SUBSCRIPTION_PLANS[plan];
};
